const baseURL = 'https://credito.mediosmoviles.net/';

export default baseURL;
